<template>
  <transition name="slide-fade">
    <div class="panel">
      <p class="intro-text">
        You can download, print, and use the Chronic Pancreatitis Pain Guide
        worksheets available here to support your self-care practices. These
        tools can help you build resilience, develop a relaxation practice,
        assist you in reframing your thoughts to improve how you feel, and
        manage your emotions. There's also a worksheet to help you prepare for
        visits with your healthcare provider to make sure that you get what you
        need from the conversations. The more you practice these skills, the
        more effective you will be. Good luck!
      </p>

      <ul>
        <li>
          <a
            href="/app/worksheets/worksheet-acts-of-kindness.pdf"
            target="_blank"
            rel="noopener noreferrer"
            >Acts of Kindness</a
          >
          <br />
          Use this worksheet to document the acts of kindness that you extend to
          others and to yourself
        </li>

        <li>
          <a
            href="/app/worksheets/worksheet-good-things.pdf"
            target="_blank"
            rel="noopener noreferrer"
            >Good Things</a
          >
          <br />
          Use this worksheet to build resilience by focusing on positive aspects
          of your life
        </li>

        <li>
          <a
            href="/app/worksheets/worksheet-pleasant-activity.pdf"
            target="_blank"
            rel="noopener noreferrer"
            >Pleasant Activity</a
          >
          <br />
          Use this worksheet to help you to plan time for enjoyable activities
          each and every week
        </li>

        <li>
          <a
            href="/app/worksheets/worksheet-reframing.pdf"
            target="_blank"
            rel="noopener noreferrer"
            >Reframing</a
          >
          <br />
          Use this worksheet to practice reframing negative thoughts to make you
          feel more
        </li>

        <li>
          <a
            href="/app/worksheets/worksheet-savoring.pdf"
            target="_blank"
            rel="noopener noreferrer"
            >Savoring</a
          >
          <br />
          Use this worksheet to help you savor life's pleasures, both small and
          large!
        </li>

        <li>
          <a
            href="/app/worksheets/worksheet-signature-strengths.pdf"
            target="_blank"
            rel="noopener noreferrer"
            >Signature Strengths</a
          >
          <br />
          Use this worksheet to identify your signature strengths and put them
          to work
        </li>

        <li>
          <a
            href="/app/worksheets/worksheet-stress-management.pdf"
            target="_blank"
            rel="noopener noreferrer"
            >Stress Management</a
          >
          <br />
          Use this worksheet to help manage your stress
        </li>

        <li>
          <a
            href="/app/worksheets/worksheet-working-with-your-doctor.pdf"
            target="_blank"
            rel="noopener noreferrer"
            >Working With Your Doctor</a
          >
          <br />
          Use this worksheet to ensure that you know what to expect and how to
          interact during your visit
        </li>

        <li>
          <a
            href="/app/worksheets/worksheet-relaxation.pdf"
            target="_blank"
            rel="noopener noreferrer"
            >Relaxation</a
          >
          <br />
          Use this worksheet to develop and practice relaxation techniques
        </li>
      </ul>
    </div>
  </transition>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  async created() {
    this.changePageTitle("Self-care Worksheets");
    this.changePageIntroText("");
  },

  methods: {
    ...mapMutations(["changePageTitle", "changePageIntroText"]),
  },
};
</script>

<style scoped>
ul {
  margin-top: 2rem;
}

li {
  margin-bottom: 2rem;
}

a {
  color: var(--black);
  font-size: 1.125rem;
  font-weight: 600;
}

a:hover,
a:focus {
  color: var(--michigan-blue);
}

.panel {
  font-weight: 500;
  padding: 2rem;
}

.intro-text {
  line-height: 1.5;
}
</style>
